import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedRelative } from 'react-intl';
import { Icon } from '@99designs/common/components/Icon';
import { Avatar } from '@99designs/common/components/Avatar';
import PaneSpinner from 'components/PaneSpinner';
import { Spinner } from '@99designs/common/components/Spinner';
import { get } from 'utils/xhr';

export default class LikesSidebarBody extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            likes: props.likes,
            isLoading: false,
            totalPages: 0,
            currentPage: 0,
            designLikesUrl: props.designLikesUrl,
        };

        this.getLikes = this.getLikes.bind(this);
    }

    componentDidMount() {
        this.getLikes();
    }

    componentWillUnmount() {
        this.abortRequest();
    }

    abortRequest() {
        if (this.request) {
            this.request.abort();
        }
    }

    getLikes() {
        this.setState(
            () => ({
                isLoading: true,
            }),
            this.fetchLikes()
        );
    }

    fetchLikes() {
        this.abortRequest();

        this.request = get(this.state.designLikesUrl);
        this.request
            .then(({ body }) => {
                this.setState(prevState => {
                    return {
                        likes: prevState.likes.concat(body.users),
                        isLoading: false,
                        designLikesUrl: body.paginationUrl,
                        totalPages: body.totalPages,
                        currentPage: body.currentPage,
                    };
                });
            })
            .catch(() => {
                this.setState(() => ({
                    likes: [],
                    isLoading: false,
                    designLikesUrl: '',
                    totalPages: 1,
                    currentPage: 1,
                }));
            });
    }

    likesPanel() {
        return (
            <span>
                {this.likesList()}
                {this.showMore()}
            </span>
        );
    }

    likesList() {
        if (this.state.likes.length === 0 && this.state.isLoading) {
            const paneRect = this.bodyElement.getBoundingClientRect();
            return (
                <PaneSpinner
                    paneTop={paneRect.top}
                    viewportHeight={document.documentElement.clientHeight}
                    paneHeight={paneRect.height}
                />
            );
        }

        return this.state.likes.map(user => (
            <a
                rel="nofollow noopener noreferrer"
                href={user.showUrl}
                target="_blank"
                key={user.userId}
                className="section-action section-action--joined"
            >
                <span className="section-action--joined__inner">
                    <span className="flag flag--middle flag--small">
                        <span className="flag__mast">
                            <Avatar
                                user={{ avatarUrl: user.avatarUrl, id: user.userId }}
                                variations={['small']}
                            />
                        </span>
                        <span className="flag--small__flag flag__flag">
                            {user.name}
                            <span className="section-action__label__meta">
                                <FormattedRelative style="numeric" value={user.timeCreated} />
                            </span>
                        </span>
                    </span>
                </span>
            </a>
        ));
    }

    showMore() {
        if (this.state.currentPage === this.state.totalPages) return null;

        return (
            <span className="section-action section-action--joined">
                <span className="section-action--joined__inner">
                    <button className="button button--link" onClick={this.getLikes}>
                        <FormattedMessage id="show_more" />
                    </button>
                    {this.state.isLoading && <Spinner variations={['inline', 'soft']} />}
                </span>
            </span>
        );
    }

    render() {
        return (
            <div>
                <div>
                    <button
                        className="section-action section-action--primary"
                        onClick={this.props.onOverviewButtonClick}
                    >
                        <span className="section-action__icon--left">
                            <Icon variations={['left-2']} />
                        </span>

                        <span className="section-action__label">
                            <FormattedMessage id="back_to_overview" />
                        </span>
                    </button>
                </div>
                <div
                    ref={element => {
                        this.bodyElement = element;
                    }}
                    style={{ position: 'relative' }}
                >
                    {this.likesPanel()}
                </div>
            </div>
        );
    }
}

LikesSidebarBody.defaultProps = {
    designLikesUrl: '',
};

LikesSidebarBody.propTypes = {
    likes: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            createdAt: PropTypes.string.isRequired,
            userId: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            timeCreated: PropTypes.string.isRequired,
            showUrl: PropTypes.string.isRequired,
            avatarUrl: PropTypes.string.isRequired,
        })
    ),
    onOverviewButtonClick: PropTypes.func.isRequired,
    designLikesUrl: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/LikesSidebarBody.jsx